export type MediaGallerySourceKey = 'scanPositions' | 'image360';

export const ColorScanPositionColor = '#00FFFB';
export const BlackAndWhiteScanPositionColor = '#FFD400';
export const BlackAndWhiteScanPositionGlowColor = '#665500';
const PanoColorTypes = {
    Color: 0 as PanoColorType,
    BlackAndWhite: 1 as PanoColorType
} as const;

export function hasViewRotation(view?: { Rotation?: { X?: number; Y?: number; Z?: number; W?: number } } | null): boolean {
    const rotation = view?.Rotation;

    return rotation?.X != null &&
        rotation?.Y != null &&
        rotation?.Z != null &&
        rotation?.W != null;
}

export function hasScanMedia(view?: { ScanFileData?: I360ScanData | string | null; DepthMapUrl?: string | null } | null): boolean {
    if (!view) {
        return false;
    }

    const scanFileData = view.ScanFileData;
    const hasScanData = typeof scanFileData === 'string'
        ? scanFileData.trim().length > 0
        : !!scanFileData?.ScanDatas?.length;

    return hasScanData || !!view.DepthMapUrl;
}

export function isScanPositionView(view?: IView360Detail | null): boolean {
    return hasScanMedia(view);
}

export function getScanPositionPanoColorType(view?: IView360Detail | null): PanoColorType | null {
    if (!isScanPositionView(view)) {
        return null;
    }

    return view?.PanoColorType === PanoColorTypes.BlackAndWhite
        ? PanoColorTypes.BlackAndWhite
        : PanoColorTypes.Color;
}

export function isBlackAndWhiteScanPosition(view?: IView360Detail | null): boolean {
    return getScanPositionPanoColorType(view) === PanoColorTypes.BlackAndWhite;
}

export function getViewMediaKind(view: IView360Detail): MediaGallerySourceKey {
    return isScanPositionView(view) ? 'scanPositions' : 'image360';
}

export function toHeadingDegrees(rotation?: IQuaternion | null): number | null {
    if (!hasViewRotation({ Rotation: rotation ?? undefined })) {
        return null;
    }

    const sinyCosp = 2 * ((rotation.W * rotation.Y) + (rotation.Z * rotation.X));
    const cosyCosp = 1 - (2 * ((rotation.Y * rotation.Y) + (rotation.X * rotation.X)));
    const angle = Math.atan2(sinyCosp, cosyCosp) * (180 / Math.PI);
    return (angle + 360) % 360;
}

export function toScanPositionHeadingDegrees(rotation?: IQuaternion | null): number | null {
    if (!hasViewRotation({ Rotation: rotation ?? undefined })) {
        return null;
    }

    const directionX = rotation.X;
    const directionZ = rotation.Y;
    if (directionX === 0 && directionZ === 0) {
        return null;
    }

    const angle = Math.atan2(directionX, directionZ) * (180 / Math.PI);
    return (angle + 360) % 360;
}

export function toMediaGalleryHeadingDegrees(view?: IView360Detail | null): number | null {
    if (!view) {
        return null;
    }

    return isScanPositionView(view)
        ? toScanPositionHeadingDegrees(view.Rotation)
        : toHeadingDegrees(view.Rotation);
}
